import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {Camera, Link, Rocket, Type} from "lucide-react";
import {MenuItem, MenuItemIcon, MenuItemText} from './sheet';

const SelectPostTypeSheet = styled(({className, community, onClose}) => {

    const history = useHistory();
    const handleCreatePost = (type) => {
        onClose();
        history.push(`${community ? `/c/${community}/submit` : '/submit'  }?type=${type}`);
    };

    return (
        <div className={className}>
            <MenuItem onClick={() => handleCreatePost('media')}>
                <MenuItemIcon>
                    <Camera size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Media Post
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={() => handleCreatePost('link')}>
                <MenuItemIcon>
                    <Link size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Link Post
                </MenuItemText>
            </MenuItem>
            <MenuItem onClick={() => handleCreatePost('text')}>
                <MenuItemIcon>
                    <Type size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Text Post
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default SelectPostTypeSheet;
